'use client';
import React, { createContext, useContext, useState, useCallback } from 'react';

const ToolsContext = createContext({
  open: false,
  handleOpenChange: () => {},
});

export const useToolsContext = () => {
  return useContext(ToolsContext);
};

export const ToolsPanelProvider = ({ children }) => {
  const localWindow = typeof window !== 'undefined' ? window : null;
  const [open, setOpen] = useState(
    Boolean(Number(localWindow?.localStorage.getItem('toolsOpen')))
  );

  const handleOpenChange = useCallback(
    (toolsOpen) => {
      if (!localWindow) {
        return;
      }

      setOpen(toolsOpen);

      if (toolsOpen) {
        localWindow.localStorage.setItem('toolsOpen', '1');
        setOpen(true);
      } else {
        localWindow.localStorage.setItem('toolsOpen', '0');
        setOpen(false);
      }
    },
    [localWindow]
  );

  return (
    <ToolsContext.Provider value={{ open, handleOpenChange }}>
      {children}
    </ToolsContext.Provider>
  );
}; 